import(/* webpackMode: "eager" */ "/home/interim/frontend/app/pricing/page.tsx");
